import { useEffect, useState } from 'react';
import { SelectArrayInput, SelectInput } from 'react-admin';
import { fetchCaretakerPreference } from '../fleet/myVehiclesApi';
import { useHasPermission } from '../PermissionGate';
import { planningStatusChoices } from './planningStatus';
import { useStatuses } from './statusDictionary';
import { asStatusList, statusListOrNothing } from './bankFtl';

/**
 * Filtry listy banku z makiety FTL (pkt 9.3, przełącznik `bankFtlFilters`,
 * 15.10.2026). Klucze to kontrakt z API (`user-offers/bank-ftl.ts`); stare
 * klucze bez zmian. Nowe pola idą do „Dodaj filtr” — wiersz filtrów stałych
 * zostaje, jaki był (mieści się przy 1366 px); domyślny widok roli pokazuje
 * swoje pola sam (`displayedFilters`). Tablica pól z kluczami stoi
 * w `UserOfferList.tsx` (`bankFtlFilters`) — tam czyta ją strażnik kluczy.
 */

/**
 * „Stan planowania” z wyborem kilku stanów naraz (makieta: „Gotowe”
 * i „Wstępnie planowane” razem). Ten sam klucz `planningStatus` — API
 * przyjmowało listę od początku. Zapamiętany pojedynczy stan (sprzed
 * przełącznika) wchodzi jako lista z jednym stanem; pusty wybór = brak
 * filtra (stany żywe z API).
 */
export const PlanningStatusMultiFilter = (props: { source: string; label: string; alwaysOn?: boolean }) => {
  const states = useStatuses();
  return (
    <SelectArrayInput
      {...props}
      choices={planningStatusChoices(states)}
      format={asStatusList}
      parse={statusListOrNothing}
      sx={{ minWidth: 200 }}
    />
  );
};

/**
 * Opiekun FTL auta obsadzonego albo wariantu („planista” z makiety). Lista
 * opiekunów z kartoteki aut (`GET /ftl-caretakers/me`, sekcja planowania
 * FTL) — bez uprawnienia filtra nie ma (API opiekunów odpowiada 403).
 */
export const CaretakerFilter = (props: { source: string; label: string; alwaysOn?: boolean }) => {
  const canPlan = useHasPermission('FTL_PLANNING');
  const [choices, setChoices] = useState<Array<{ id: string; name: string }>>([]);
  useEffect(() => {
    if (!canPlan) return undefined;
    let alive = true;
    void fetchCaretakerPreference()
      .then((p) => {
        if (alive) setChoices(p.caretakers.map((c) => ({ id: c, name: c })));
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, [canPlan]);
  if (!canPlan) return null;
  return <SelectInput {...props} choices={choices} />;
};
